import { Box, Button } from "@mui/material";
import React, { useCallback, useState } from "react";
import GoToIcon from "../IconComp/goToIcon";
import { ColorPallet } from "../../utils/colorPallet";
import Calendar from "./calender";
import { getQuickReportsData } from "../../features/quickReport/quickReportSlice";
import { useAppDispatch } from "../../app/hooks";


interface IProps {
  data: any[];
  title: string;
  buttonTitle: string;
  onClick?: () => void;
}

const QuickMonthlyReport = ({ data, title, buttonTitle, onClick }: IProps) => {
 
  
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const dispatch = useAppDispatch();  const pharmacyId = localStorage.getItem("pharmacyId");

  const getQuickReports = useCallback((month:any, year:any) => {
    // dispatch(getQuickReportsData(pharmacyId));
    dispatch(getQuickReportsData({ pharmacyId: pharmacyId , month: month, year: year }));
  }, [dispatch]);


  const toggleCalendar = () => {
    setIsCalendarOpen(!isCalendarOpen);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          bgcolor: ColorPallet.bgcolor,
          border: `1px solid ${ColorPallet.borderColor}`,
          width: "100%",
          borderRadius: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            borderBottom: `1px solid ${ColorPallet.borderColor}`,
            paddingTop: 2,
            paddingBottom: 1,
          }}
        >
          <Box
            sx={{
              fontSize: "16px",
              fontWeight: "bold",
              paddingLeft: { xs: "10px", sm: "20px" },
              marginTop: "3px",
            }}
          >
            {title}
          </Box>
          <Box
            sx={{
              paddingRight: "20px",
              cursor: "pointer",
            }}
          >
            <Button
              style={{
                textTransform: "capitalize",
              }}
              onClick={toggleCalendar}
            >
          <Calendar onMonthChange={getQuickReports}/>
              {/* {buttonTitle}
              <GoToIcon /> */}
            </Button>
          </Box>
        </Box>
        {data.length === 0 ? (
          <Box sx={{ p: 5, textAlign: "center" }}>No data available</Box>
        ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            p: 3,
            pt: 8,
          }}
        >
          {data?.map((item: any, index: number) => (
            <Box>
              <Box sx={{ fontWeight: "bold" }}>{item?.totalMedicines?.toLocaleString("en-IN")}</Box>
              <Box sx={{ mt: 1 }}>{item?.title}</Box>{" "}
            </Box>
          ))}
        </Box>
        )}
      </Box>
    </>
  );
};

export default QuickMonthlyReport;
